export default __webpack_public_path__ + "static/media/contactMail.d4c9ac42.png";